// extracted by mini-css-extract-plugin
var _1 = "EditorPlaceholder-module__actions--EhktG";
var _2 = "EditorPlaceholder-module__animatedBackground--w9muv";
var _3 = "EditorPlaceholder-module__button--r6arn";
var _4 = "EditorPlaceholder-module__container--p54sN";
var _5 = "EditorPlaceholder-module__content--gl7HR";
var _6 = "EditorPlaceholder-module__fileInput--_PHat";
var _7 = "EditorPlaceholder-module__fileInputLabel--YPb4K";
var _8 = "EditorPlaceholder-module__icon--tKl6r";
var _9 = "EditorPlaceholder-module__note--RU4r4";
var _a = "EditorPlaceholder-module__template--UietB";
var _b = "EditorPlaceholder-module__templatesActions--wwyPL";
var _c = "EditorPlaceholder-module__templatesList--mUzTK";
var _d = "EditorPlaceholder-module__title--WLosK";
export { _1 as "actions", _2 as "animatedBackground", _3 as "button", _4 as "container", _5 as "content", _6 as "fileInput", _7 as "fileInputLabel", _8 as "icon", _9 as "note", _a as "template", _b as "templatesActions", _c as "templatesList", _d as "title" }
